// Production builds don't write debug output to the browser console: much of it contains tokens,
// login responses and personal data. Warnings and errors are kept.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.table = noop;
}

export {};
